// @ts-strict-ignore
export function executeRecaptchaPromise(): Promise<string> {
  return new Promise((resolve, reject) => {
    window[`handleRecaptchaResponse`] = (recaptchaToken: string) => {
      resolve(recaptchaToken);
      delete window[`handleRecaptchaResponse`];
      delete window[`handleRecaptchaError`];
    };
    window[`handleRecaptchaError`] = () => {
      reject(new Error(`Unexpected recaptcha error`));
      delete window[`handleRecaptchaResponse`];
      delete window[`handleRecaptchaError`];
    };

    try {
      return window[`grecaptcha`].execute();
    } catch (err) {
      reject(err as Error);
    }
  });
}
